import { SmartDatePicker } from 'app/components/shared/FormComponents/SmartDatePicker'
import { SmartInput } from 'app/components/shared/FormComponents/SmartInput'
import { SmartRadioGroup } from 'app/components/shared/FormComponents/SmartRadioGroup'
import { FormGroup } from 'app/components/shared/FormGroup'
import { FormTooltip } from 'app/components/shared/FormTooltip'
import { RadioFormGroup } from 'app/components/shared/RadioFormGroup'
import { Grid } from 'app/components/ui/Grid'
import { Radio } from 'app/components/ui/RadioGroup/Radio'
import { Text } from 'app/components/ui/Text'
import { CompanyTypes, RegistrationTypes } from 'EstraSponsor'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTheme } from 'styled-components'

const companyTypes: {
  [key in CompanyTypes]: string
} = {
  individuale: 'Ditta individuale',
  snc: 'Snc',
  srl: 'Srl',
  sas: 'Sas',
  ssd: 'Ssd',
  asd: 'Asd',
  spa: 'Spa',
  sapa: 'Sapa',
  cooperativa: 'Cooperativa',
  scs: 'Scs',
  srlu: 'Srlu',
  ss: 'Ss',
  ati: 'Ati',
  ente: 'Ente',
  associazione: 'Associazione',
  fondazione: 'Fondazione',
  consorzio: 'Consorzio',
  onlus: 'Onlus',
  privato: 'Privato',
}

const registrationTypes: {
  [key in RegistrationTypes]: string
} = {
  body: 'Ente / Associazione',
  company: 'Azienda',
}

export const CompanyFormSection = (): JSX.Element => {
  const theme = useTheme()

  const { watch } = useFormContext()

  const registrationTypeWatcher = watch(`registration_type`)

  return (
    <>
      <Grid cols={[6, 3, 3]}>
        <FormGroup>
          <SmartInput
            label='Ragione sociale'
            name='company_name'
            labelRequired
          ></SmartInput>
        </FormGroup>
        <FormGroup>
          <SmartInput
            label='Forma giuridica'
            name='company_type'
            type='select'
            labelRequired
            selectCaretSize='small'
          >
            <option value={''}>Seleziona</option>
            {Object.keys(companyTypes).map((optValue) => (
              <option key={optValue} value={optValue}>
                {companyTypes[optValue as CompanyTypes]}
              </option>
            ))}
          </SmartInput>
        </FormGroup>
        <FormGroup>
          <SmartInput
            label='Tipologia azienda'
            name='registration_type'
            type='select'
            labelRequired
            selectCaretSize='small'
          >
            <option value={''}>Seleziona</option>
            {Object.keys(registrationTypes).map((optValue) => (
              <option key={optValue} value={optValue}>
                {registrationTypes[optValue as RegistrationTypes]}
              </option>
            ))}
          </SmartInput>
        </FormGroup>
      </Grid>
      <Grid cols={[4, 4, 4]}>
        <FormGroup>
          <SmartInput
            label='Codice Fiscale'
            name='company_fiscal_code'
            labelRequired
          />
        </FormGroup>

        {registrationTypeWatcher === 'company' && (
          <FormGroup>
            <SmartInput label='Partita IVA' name='company_vat' labelRequired />
          </FormGroup>
        )}
      </Grid>

      <FormGroup>
        <SmartInput
          label="Descrizione attività dell'azienda (Massimo 100 caratteri)"
          name='company_activity'
          labelRequired
          maxLength={100}
        />
      </FormGroup>

      <Grid cols={[4, 4, 4]}>
        <FormGroup>
          <SmartInput
            label='Num. iscrizione C.C.I.A.A.'
            name='company_cciaa_nr'
          />
        </FormGroup>

        <FormGroup>
          <SmartDatePicker
            label='Data iscrizione C.C.I.A.A.'
            name='company_cciaa_date'
          />
        </FormGroup>
        <FormGroup>
          <SmartDatePicker
            label="Data inizio attività d'impresa"
            name='company_date_start'
          />
        </FormGroup>
      </Grid>

      <Grid cols={[4, 4, 4]}>
        <FormGroup>
          <SmartRadioGroup
            label='Appartenente al regime fiscale minimo?'
            name='company_minimum_tax'
          >
            <RadioFormGroup>
              <Radio value={false}>No</Radio>
              <Radio value={true}>Sì</Radio>
            </RadioFormGroup>
          </SmartRadioGroup>
        </FormGroup>
        <FormGroup>
          <SmartRadioGroup
            label='A regime IVA forfettario legge n° 398/91?'
            name='flat_rate_vat'
          >
            <RadioFormGroup>
              <Radio value={false}>No</Radio>
              <Radio value={true}>Sì</Radio>
            </RadioFormGroup>
          </SmartRadioGroup>
        </FormGroup>

        <FormTooltip
          tooltipText={`La ritenuta d'acconto si applica ai liberi professionisti, in caso di prestazioni occasionali:\nÈ necessario pertanto specificare la percentuale.`}
        >
          <FormGroup>
            <SmartInput
              label='Tipologia e % di ritenuta fiscale da applicare'
              name='company_withholding_tax'
            />
          </FormGroup>
        </FormTooltip>
      </Grid>
      <FormGroup>
        <Text variant='s14' color={theme.color.primari.grigioEstra}>
          Pur essendo Estra S.p.A. soggetta a regime di Split Payment, in virtù
          del vostro regime speciale IVA è richiesto un invio di regolare
          fattura senza alcuna modifica, esplicitando nelle eventuali fatture
          solo il regime fiscale agevolato a cui si è sottoposti.
        </Text>
      </FormGroup>
    </>
  )
}
